module.exports = __webpack_public_path__ + "static/media/select-seta-bg.a873cedd.svg";